import type { Layer } from "leaflet";
import { createContext } from "react";

import type { Option } from "@/types/util-types";

export interface FixtureLayerEntry {
    layers: Layer[];
}

export interface FixtureSelectionContextType {
    /**
     * Retrieves the layer entry for a given fixture.
     *
     * @param uniqueId - The unique identifier of the fixture.
     */
    get: (uniqueId: string) => Option<FixtureLayerEntry>;
    /**
     * Registers layers for a fixture and returns a cleanup function.
     *
     * @param uniqueId - The unique identifier of the fixture.
     * @param layers - The Leaflet layers to register.
     */
    add: (uniqueId: string, ...layers: Layer[]) => () => void;
}

/**
 * Shared context for coordinating multi-fixture drag operations.
 *
 * Provides a registry of Leaflet layers keyed by fixture `uniqueId`, allowing
 * any fixture component (Light, Marker, etc.) to discover and include other
 * selected fixtures' layers as `subLayers` during a drag.
 */
export const FixtureSelectionContext =
    createContext<Option<FixtureSelectionContextType>>(undefined);
